import type { ApiErrorData } from '../../api/model';

export const isApiErrorData = (data: unknown): data is ApiErrorData =>
  typeof data === 'object' &&
  data !== null &&
  Array.isArray(data) &&
  data.every(
    (item) => typeof item === 'object' && item !== null && typeof item.detail === 'string',
  );
